import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="study-subject-csv-upload"
export default class extends Controller {
  static outlets = ["nested-form"]

  appendAnswers(event) {
    const uploadedAnswers = event.detail.answers || []
    if (uploadedAnswers.length === 0 || !this.hasNestedFormOutlet) return

    uploadedAnswers.forEach(answer => {
      this.nestedFormOutlet.appendField(answer.name)
    })
  }
}
